import { createSlice } from '@reduxjs/toolkit';

/**
 * @fileoverview Slice Redux para gerenciamento do modal de categorias.
 * Controla estado de abertura/fechamento do CategoryManager.
 * 
 * @module CategoryManagerSlice
 * @since 1.0.0
 */

const categoryManagerSlice = createSlice({
  name: 'categoryManager',
  initialState: {
    isOpen: false,
  },
  reducers: {
    /**
     * Abre o modal de gerenciamento de categorias.
     */
    openCategoryManager: (state) => {
      state.isOpen = true;
    },
    /**
     * Fecha o modal de gerenciamento de categorias.
     */
    closeCategoryManager: (state) => {
      state.isOpen = false;
    },
  },
});

export const { openCategoryManager, closeCategoryManager } = categoryManagerSlice.actions;
export default categoryManagerSlice.reducer;
